// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"1c1b212e","112":"1c1b212e","125":"1c1b212e","309":"1c1b212e","386":"1c1b212e","680":"1c1b212e","704":"1c1b212e","723":"1c1b212e"}[chunkId] + ".chunk.css";
};